<template>
  <EdroneModal
    v-if="showNotification && !isDev"
    :class="$options.name"
    :open="showNotification"
    :close-on-esc-key-press="false"
    :close-on-outside-click="false"
    :show-close-icon="true"
    width="1100"
    @close="showNotification = false"
  >
    <div class="tw:flex tw:max-h-[calc(100vh_-_6.25rem)] tw:overflow-y-auto tw:flex-wrap">
      <div class="tw:w-full tw:md:w-1/2 tw:p-10 tw:flex tw:flex-col tw:gap-10">
        <div class="tw:mx-auto">
          <img src="https://d3vhsxl1pwzf0p.cloudfront.net/edrone-shoper-logos.png" />
        </div>
        <div class="tw:text-center">
          <h3 class="tw:heading-1 tw:mb-6">{{ trans._integrationV2.shoper.reinstall.title }}</h3>
          <p class="tw:body-1" v-html="trans._integrationV2.shoper.reinstall.desc" />
        </div>
        <EdroneAlert
          class="tw:mt-auto"
          :title="trans._integrationV2.shoper.reinstall.notification.title"
          :desc="trans._integrationV2.shoper.reinstall.notification.desc"
          type="caution"
        />
      </div>
      <div class="tw:w-full tw:md:w-1/2 tw:p-10 tw:bg-default-100 tw:rounded-md tw:h-full">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="tw:relative tw:ps-7 tw:border-l tw:ms-4 tw:pb-8"
          :class="index === 3 ? 'tw:border-transparent' : 'tw:border-default-900'"
        >
          <EdroneBadge
            type="default"
            solid
            :label="(index + 1).toString()"
            class="tw:absolute tw:top-0 tw:-left-[1.0625rem]"
          />
          <h3 class="tw:heading-2" v-html="step.title" />
          <p class="tw:body-2 tw:!text-default-700" :class="index === 0 ? 'tw:mb-6' : ''" v-html="step.description" />
          <EdroneButton v-if="index === 0" @click="goToShoper">
            {{ trans._integrationV2.shoper.reinstall.buttons.shoper }}
            <template #right-icon>
              <font-awesome-icon icon="fa-light fa-arrow-up-right-from-square" />
            </template>
          </EdroneButton>
        </div>

        <div class="tw:text-center tw:mt-auto">
          <p class="tw:caption tw:!text-default-800">
            {{ trans._integrationV2.shoper.reinstall.helper.title }}
          </p>
          <p class="tw:caption tw:!text-default-800 tw:mb-2">
            {{ trans._integrationV2.shoper.reinstall.helper.desc }}
          </p>
          <EdroneButton type="outline" class="tw:mx-auto" @click="handleContactSupport">
            {{ trans._integrationV2.shoper.reinstall.buttons.chat }}
          </EdroneButton>
        </div>
      </div>
    </div>
  </EdroneModal>
</template>

<script lang="ts">
export default {
  name: "ShoperReinstallNotification",
};
</script>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import EdroneModal from "edrone-components/EdroneModal.vue";
import EdroneAlert from "edrone-components/EdroneAlert.vue";
import EdroneBadge from "edrone-components/EdroneBadge/EdroneBadge.vue";
import EdroneButton from "edrone-components/EdroneButton.vue";
import { showIntercomChat } from "vue-app/utils/functions";
import { getShouldReinstallModule } from "vue-app/api/integration/shoper.ts";

const isDev = window.EDRONE_CONTEXT.user.isDev;
const showNotification = ref(false);
const steps = ref([
  {
    title: window._trans._integrationV2.shoper.reinstall.steps[0].title,
    description: window._trans._integrationV2.shoper.reinstall.steps[0].desc,
  },
  {
    title: window._trans._integrationV2.shoper.reinstall.steps[1].title,
    description: window._trans._integrationV2.shoper.reinstall.steps[1].desc,
  },
  {
    title: window._trans._integrationV2.shoper.reinstall.steps[2].title,
    description: window._trans._integrationV2.shoper.reinstall.steps[2].desc,
  },
  {
    title: window._trans._integrationV2.shoper.reinstall.steps[3].title,
    description: window._trans._integrationV2.shoper.reinstall.steps[3].desc,
  },
]);

function handleContactSupport() {
  showIntercomChat();
}

function goToShoper() {
  window.open("https://www.shoper.pl/myadmin", "_blank");
}

onMounted(async () => {
  showNotification.value = await getShouldReinstallModule();
});
</script>

<style lang="scss">
.ShoperReinstallNotification {
  .EdroneModal__close-icon {
    top: 0.5rem;
    right: 0.5rem;
  }

  p br {
    display: block;
    margin-bottom: 0.5rem;
    content: "";
  }
}
</style>
